import type { PlainRunner } from "@/queries/runner-queries";
import type { RunnerTemplate } from "@/components/runners/RunnerTemplateSelection";

export const TEMPLATE_URLS = {
    standard: "https://gitpod-flex-releases.s3.amazonaws.com/ec2/stable/gitpod-ec2-runner.json",
    enterprise:
        "https://gitpod-flex-releases.s3.amazonaws.com/ec2/stable/gitpod-ec2-runner-enterprise-with-custom-network.json",
} as const;

// Default to standard template for backward compatibility
const getTemplateURL = (template?: RunnerTemplate): string => {
    if (!template) return TEMPLATE_URLS.standard;
    return TEMPLATE_URLS[template] || TEMPLATE_URLS.standard;
};

export function createRunnerSetupURL(
    runner: PlainRunner,
    accessToken: string,
    region: string,
    cpURL = `${window.location.origin}/api`,
    template?: RunnerTemplate,
) {
    const templateURL = getTemplateURL(template);
    return `https://${region}.console.aws.amazon.com/cloudformation/home?region=${region}#/stacks/create/review?templateURL=${templateURL}&stackName=${stackName(runner.name)}&param_ExchangeToken=${accessToken}&param_APIEndpoint=${cpURL}&param_RunnerID=${runner.runnerId}`;
}

export function createRunnerSetupText(
    runner: PlainRunner,
    accessToken: string,
    region: string,
    cpURL = `${window.location.origin}/api`,
    template?: RunnerTemplate,
) {
    const templateURL = getTemplateURL(template);
    return `
        Configuration details for ${runner?.name} runner

        Template:
        ${template || "standard"}

        Region:
        ${region}

        CloudFormation template URL:
        ${templateURL}

        Stack Name:
        ${stackName(runner.name)}

        Runner ID:
        ${runner.runnerId}

        Runner Token:
        ${accessToken}

        Endpoint:
        ${cpURL}
    `
        .split("\n")
        .map((line) => line.trimStart())
        .join("\n");
}

export function stackName(runnerName: string) {
    // Stack name can include letters (A–Z and a–z), numbers (0–9) and dashes (-).
    const name = runnerName.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9\\-]/g, "");
    return `Gitpod-${name}`;
}
